// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Mm-z","tupacHeader":"Nm-z","tupacHeader2":"Om-z","tupacMenu":"Pm-z","tupacMenu2":"Qm-z","tupacMain":"Rm-z","tupacMain2":"Sm-z"};